/** Trailing digits only, so "B-1" and "S-08" both display as a plain number. */
export function displayLockerNumber(number) {
  const match = String(number ?? "").match(/(\d+)\s*$/);
  if (!match) return String(number ?? "").trim();
  return String(parseInt(match[1], 10));
}

export function lockerNumberSortValue(number) {
  const match = String(number ?? "").match(/(\d+)\s*$/);
  if (!match) return Number.MAX_SAFE_INTEGER;
  return parseInt(match[1], 10);
}
